export default __webpack_public_path__ + "static/media/slider2.1bc17ee6.jpg";